
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Edit, Trash2, GripVertical } from "lucide-react";
import * as LucideIcons from "lucide-react";

interface FeaturedProductCardProps {
  product: any;
  onEdit: (product: any) => void;
  onDelete: (id: string) => void;
  dragHandleProps?: any;
  innerRef?: any;
  isDragging?: boolean;
}

const FeaturedProductCard = ({
  product,
  onEdit,
  onDelete,
  dragHandleProps,
  innerRef,
  isDragging = false,
}: FeaturedProductCardProps) => {
  const Icon = (LucideIcons as any)[product.icon_name] || LucideIcons.Sparkles;

  return (
    <div
      ref={innerRef}
      {...(dragHandleProps || {})}
      className={`border rounded-lg p-4 space-y-3 ${
        !product.is_active ? "opacity-50" : ""
      } ${
        isDragging
          ? "ring-2 ring-blue-500 shadow-md bg-accent transition"
          : ""
      }`}
    >
      <div className="flex items-center justify-between">
        <div {...(dragHandleProps || {})}>
          <GripVertical className="h-4 w-4 text-muted-foreground cursor-move" />
        </div>
        <Badge variant={product.is_active ? "default" : "secondary"}>
          {product.is_active ? "Active" : "Inactive"}
        </Badge>
      </div>

      <div className="flex flex-col items-center text-center space-y-2">
        <div className="w-16 h-16 bg-muted rounded-lg flex items-center justify-center">
          <Icon className="h-8 w-8 text-primary" />
        </div>
        <div>
          <h3 className="font-semibold">{product.name}</h3>
          <p className="text-sm text-muted-foreground">{product.category}</p>
        </div>
      </div>

      <div className="flex justify-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onEdit(product)}
        >
          <Edit className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDelete(product.id)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default FeaturedProductCard;
